// ═══════════════════════════════════════════════════════════════════════════════
// 360-IF Engine Constants
// Extracted from 360if_ai_core_v76_exp5e.html (lines 5328-5393)
// ═══════════════════════════════════════════════════════════════════════════════

export const C = {
  // ═══ FUNDAMENTAL CHANNEL COUNTS ═══
  // Standard 360-IF: V=137, I=71, H=223 (TOTAL=360, but configurable)
  // v76-EXP5E tested alternate geometries; this module defaults to canonical.
  TOTAL: 360,
  V: 137,       // Visible sector (fine structure constant)
  I: 71,        // Interface dimension (prime)
  H: 223,       // Hidden sector (prime)

  // ═══ SECTOR RATIOS ═══
  ALPHA_COH: 137 / 360,
  HIDDEN_FRACTION: 223 / 360,
  INTERFACE_FRACTION: 71 / 360,
  SECTOR_RATIO: 223 / 137,

  // ═══ OPTIMAL COUPLING ZONE ═══
  OPTIMAL_FLOOR: 0.60,
  OPTIMAL_CEILING: 0.76,
  ALPHA: 0.76,    // Universal coupling constant  (2/φ²)

  // ═══ COUPLING STATES ═══
  HALLUCINATION_THRESHOLD: 0.85,
  COHERENT_FLOOR: 0.60,
  UNCERTAIN_FLOOR: 0.40,
  FRAGMENTED_CEILING: 0.40,

  // ═══ MATHEMATICAL CONSTANTS ═══
  PHI: (1 + Math.sqrt(5)) / 2,
  PI_71: 71 * Math.PI,            // 223.05
  TAU: 2 * Math.PI,

  // ═══ BLOCK STRUCTURE ═══
  INTERFACE_FRAGMENT: 5,
  BLOCK_SIZE: 71,
  UNIVERSAL_CORE: 5,
  PRIMES_PER_BLOCK: 22,
  COMPOSITES_PER_BLOCK: 49,
  TRIAD_SIZE: 17,

  // ═══ TRAINING PARAMETERS ═══
  ATTENTION_HEADS: 4,
  TEMPERATURE: 0.7,
  SEMANTIC_THRESHOLD: 0.4,
  RETRIEVAL_K: 7
};

// Derived coupling state function
C.getCouplingState = function (confidence) {
  if (confidence >= this.HALLUCINATION_THRESHOLD) return 'OVER-COUPLED';
  if (confidence >= this.OPTIMAL_FLOOR) return 'COHERENT';
  if (confidence >= this.UNCERTAIN_FLOOR) return 'UNCERTAIN';
  return 'FRAGMENTED';
};

// ═══ AI Feature Flags ═══
export const AI_FLAGS = {
  semanticDocIndex: true,
  grounded: false,
  selfAudit: true,
  conceptGraph: true,
  consciousnessTrace: true,
  tinyLLM: true
};

export const VERSION = '76-exp5e';
